import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es un libro físico?',
  a: 'No, es un archivo digital listo para descargar.'
}, {
  q: '¿Cuándo lo recibo?',
  a: 'Lo recibís al instante después de la compra.'
}, {
  q: '¿Lo puedo imprimir?',
  a: 'Sí, está pensado para que lo puedas imprimir y completar cómodamente.'
}, {
  q: '¿Necesito saber jugar sudoku?',
  a: 'No necesariamente. Si te gustan los juegos de lógica, lo vas a disfrutar igual.'
}, {
  q: '¿Lo puedo compartir en casa?',
  a: 'Sí, podés imprimirlo para uso personal y hacerlo con alguien más.'
}, {
  q: '¿Se puede completar desde el celular?',
  a: 'La mejor experiencia es imprimirlo, aunque también podés verlo desde tablet o compu.'
}];
export const FAQAccordion = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="max-w-3xl mx-auto space-y-4" data-id="element-126">
      {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-127">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-128">
            <span className="font-heading font-semibold text-[#1E1E1E] text-lg" data-id="element-129">
              {faq.q}
            </span>
            <ChevronDown className={`text-[#7B2CBF] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-130" />
          </button>
          <AnimatePresence data-id="element-131">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-132">
                <div className="px-6 pb-4 text-gray-600" data-id="element-133">{faq.a}</div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
};